import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import MenuNavigator from '@scaei/back-template'
import { LoginCom, LoginWxCom, AuthorityCom, AssemblyCom, PersonalCom, SubaccountCom, SubordinateCom, OrganizationCom, UpdateInitialpwdCom, ManagementCom, MerchantCom, CandidateChangeCom, CandidateCom, CusPlatformCom, CustomerInfoCom, AccountCom,ChangePasswordCom,SubcharacterCom,CharacterCom,StageManageCom,NoticeManageCom,NoticeCategoryCom,GuideManageCom,GuideCategoryCom,SystemConfigCom } from '@scaei/back-template'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/css/element-plus.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
//引入iconfont
import '@/assets/iconfont/weixin/iconfont.css';
// 引入element-plus图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// 引入图鸟icon
import '@tuniao/tn-icon/dist/index.css'
import {preventDefaultDirective} from "@/directives";

const app = createApp(App);

// 批量注册组件
const components = [
    router, LoginCom, LoginWxCom, MenuNavigator,
    AuthorityCom, AssemblyCom, PersonalCom, SubaccountCom,
    SubordinateCom, OrganizationCom, UpdateInitialpwdCom,
    ManagementCom, MerchantCom, CandidateChangeCom,
    CandidateCom, CusPlatformCom, CustomerInfoCom,
    AccountCom, ChangePasswordCom, SubcharacterCom,
    CharacterCom, StageManageCom, NoticeManageCom,
    NoticeCategoryCom, GuideManageCom, GuideCategoryCom,
    SystemConfigCom
];

components.forEach(component => {
    app.use(component);
});

// 注册Element Plus
app.use(ElementPlus, { locale: zhCn });

// 注册全局指令
app.directive('prevent-default', preventDefaultDirective);

// 批量注册图标组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}

app.mount('#app');